import { render, staticRenderFns } from "./contrato-marco-prestacion-servicios.vue?vue&type=template&id=b9b88832&lang=html&"
import script from "./contrato-marco-prestacion-servicios.vue?vue&type=script&lang=js&"
export * from "./contrato-marco-prestacion-servicios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports